export default __webpack_public_path__ + "static/about-allfunds-e8ab9bf72c3422b228a29f18f7954852.png";